// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_2sSYM","page-link":"ryAfX","page-item":"_2z719","active":"_39y0h","disabled":"_1gfUj","pagination-lg":"N6wAT","pagination-sm":"_1ezzG","page-link-next":"_3oqHV"};